
import defaultImg from '@/assets/playturbo/icon-image-label.png';

export default {
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      layoutType: 'portal',
      defaultImg: defaultImg
    };
  },

  methods: {
    handleLayoutClick: function handleLayoutClick(layout) {
      this.layoutType = layout;
    }
  },
  computed: {
    portalPreviewUrl: function portalPreviewUrl() {
      if (this.data.length) {
        return this.data.filter(function (item) {
          return item.dimension === '720x1280';
        })[0].url;
      }
      return '';
    },
    landscapePreviewUrl: function landscapePreviewUrl() {
      if (this.data.length) {
        return this.data.filter(function (item) {
          return item.dimension === '1200x627';
        })[0].url;
      }
      return '';
    },
    layoutClass: function layoutClass() {
      return {
        'portal-layout': this.layoutType === 'portal',
        'landscape-layout': this.layoutType === 'landscape'
      };
    }
  }
};